

<!-- Main Content --> 
<app-layout *ngIf="userExists && dataLoaded"></app-layout>
<app-no-access *ngIf="!userExists"></app-no-access>


